import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class CreateRelease extends Action<StorymapState> {
    public static ACTION_TYPE = 'CreateRelease';
    public _nextOrder = 0;

    public constructor(public id: string, public name: string, public order?: number) {
        super(CreateRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: CreateRelease): Promise<boolean> => {
    const orders = state.releases.filter((x) => x.id !== null).map((x) => x.order);
    action._nextOrder = action.order ?? (orders.length === 0 ? 0 : Math.max(...orders) + 1);

    return true;
};

const reducer = (state: StorymapState, action: CreateRelease): void => {
    state.releases.filter((x) => x.order >= action._nextOrder && x.id != null).forEach((x) => x.order++);

    state.releases.push({
        goal: '',
        id: action.id,
        name: action.name,
        prefix: '',
        isArchived: false,
        isPinned: false,
        order: action._nextOrder,
        isCollapsed: false,
        archivedAt: null,
        archivedBy: null,
        releaseDate: null,
        startDate: null,
        isFocused: false,
        isNew: true,
    });
};

//@ts-ignore
registerMiddleware(CreateRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(CreateRelease.ACTION_TYPE, reducer);
